import styled from "styled-components";

const WorkSegmentSection = styled.section`
  margin: 0 0 64px 0;
`;

export { WorkSegmentSection };
